import {
    Checkbox,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    SelectChangeEvent,
    useTheme,
} from '@mui/material'
import React from 'react'
import { OrderState } from '../../services/api/sharedTypes/Common'
import { convertOrderStateTypeToString, convertStringToOrderState } from '../../utils/event-utils'
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded'

interface OrderStateFilterProps {
    orderState: OrderState[]
    onChange: (orderState: OrderState[]) => void
}

const OrderStateFilter: React.FC<OrderStateFilterProps> = ({ orderState, onChange }: OrderStateFilterProps) => {
    const theme = useTheme()

    const handleOrderSelectChange = (event: SelectChangeEvent<OrderState[]>) => {
        const {
            target: { value },
        } = event
        typeof value === 'string' ? onChange(value.split(',').map(Number)) : onChange(value)
    }

    return (
        <FormControl size='small' fullWidth style={{ maxWidth: 162, minWidth: 100, marginTop: theme.spacing(2) }}>
            <InputLabel>Stav objednávky</InputLabel>
            <Select
                multiple
                value={orderState}
                onChange={handleOrderSelectChange}
                input={<OutlinedInput label='Stav objednávky' style={{ maxHeight: 36 }} />}
                renderValue={(selected) =>
                    selected
                        .map((orderState) => convertOrderStateTypeToString(convertStringToOrderState(Number(orderState))))
                        .join(', ')
                }
            >
                <MenuItem value={OrderState.NotSet} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={orderState.indexOf(OrderState.NotSet) > -1} />
                    {convertOrderStateTypeToString(OrderState.NotSet)}
                </MenuItem>
                <MenuItem value={OrderState.Asked} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={orderState.indexOf(OrderState.Asked) > -1} />
                    {convertOrderStateTypeToString(OrderState.Asked)}
                </MenuItem>
                <MenuItem value={OrderState.OfferSent} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={orderState.indexOf(OrderState.OfferSent) > -1} />
                    {convertOrderStateTypeToString(OrderState.OfferSent)}
                </MenuItem>
                <MenuItem value={OrderState.Cancelled} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={orderState.indexOf(OrderState.Cancelled) > -1} />
                    {convertOrderStateTypeToString(OrderState.Cancelled)}
                </MenuItem>
                <MenuItem value={OrderState.CancelledWeather} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={orderState.indexOf(OrderState.CancelledWeather) > -1} />
                    {convertOrderStateTypeToString(OrderState.CancelledWeather)}
                </MenuItem>
                <MenuItem value={OrderState.OfferRejected} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={orderState.indexOf(OrderState.OfferRejected) > -1} />
                    {convertOrderStateTypeToString(OrderState.OfferRejected)}
                </MenuItem>
                <MenuItem value={OrderState.OfferAccepted} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={orderState.indexOf(OrderState.OfferAccepted) > -1} />
                    {convertOrderStateTypeToString(OrderState.OfferAccepted)}
                </MenuItem>
                <MenuItem value={OrderState.Finished} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={orderState.indexOf(OrderState.Finished) > -1} />
                    {convertOrderStateTypeToString(OrderState.Finished)}
                </MenuItem>
                <MenuItem style={{ borderTop: '1px solid gray' }}>
                    <RefreshRoundedIcon style={{ marginLeft: theme.spacing(2), marginRight: theme.spacing(2) }} />

                    <ListItemText primary='Zrušit filtr' onClick={() => onChange([])} />
                </MenuItem>
            </Select>
        </FormControl>
    )
}

export default OrderStateFilter
